"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Topic = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _animationHelper = require("animation-helper");

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3;

var NoOp = function NoOp() {};

var TopicModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(TopicModal, _ReactModal);

  function TopicModal(groupId, headerInfo) {
    var _this;

    babelHelpers.classCallCheck(this, TopicModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(TopicModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('survey-modal topic-modal');

    _this.setComponent(_react.default.createElement(Topic, {
      groupId: groupId,
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }, headerInfo));

    return _this;
  }

  return TopicModal;
}(_base.ReactModal);

exports.default = TopicModal;
var Topic = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Topic, _Component);

  function Topic() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, Topic);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Topic)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this2.state = {
      submissionComplete: false,
      submitting: false,
      topicTitle: "",
      topicBody: ""
    };
    babelHelpers.initializerDefineProperty(_this2, "groupId", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "modal", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "children", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(Topic, [{
    key: "setValue",
    value: function setValue(questionId, answer) {
      this.setState(babelHelpers.defineProperty({}, questionId, answer));
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.submitting) return false;
      return !!(this.state.topicTitle && this.state.topicBody);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.props.modal.element.firstElementChild.addEventListener('scroll', function () {
        _this3.tempScrollPosition = _this3.props.modal.element.firstElementChild.scrollTop;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.modal.element.firstElementChild.scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        className: "survey-body",
        onSubmit: this.submitTopic
      }, this.children && _react.default.createElement("div", {
        className: "survey-header"
      }, this.children), this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error === true ? 'An error occurred submitting your topic. Try again later.' : this.state.error), _react.default.createElement(TopicItem, {
        id: "topicTitle",
        required: true,
        type: "textField",
        text: "Title",
        setValue: this.setValue,
        value: this.state.topicTitle || "",
        disabled: this.state.submitting
      }), _react.default.createElement(TopicItem, {
        id: "topicBody",
        multiline: true,
        required: true,
        type: "textField",
        text: "Message",
        setValue: this.setValue,
        value: this.state.topicBody || "",
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-primary",
        disabled: !this.canSubmit()
      }, "Submit")));
    }
  }, {
    key: "submitTopic",
    value: function submitTopic(event) {
      var _this4 = this;

      event.preventDefault();

      if (this.state.submitting) {
        return;
      }

      this.setState({
        error: false,
        submitting: true
      }, function () {
        (0, _fetch.default)("data/topic/post", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            group: _this4.props.groupId,
            title: _this4.state.topicTitle,
            body: _this4.state.topicBody
          })
        }).then(function (result) {
          if (result.ok) return result.json();
          return result.json().then(function (value) {
            throw value;
          });
        }).then(function (value) {
          (0, _noty.showNotificationText)('Your topic has been created.');

          _this4.props.modal.hide();

          _SiteLayout.default.current.navigate(value.location);
        }).catch(function (e) {
          if (e.isInvalidItem) {
            _this4.setState({
              error: 'Please fill out all required fields.',
              submitting: false
            });
          } else {
            _this4.setState({
              error: true,
              submitting: false
            });
          }
        });
      });
    }
  }]);
  return Topic;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), _descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "groupId", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitTopic", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitTopic"), _class.prototype)), _class);
exports.Topic = Topic;

var TopicItem = function TopicItem(props) {
  var Type = Topic[props.type];
  return _react.default.createElement(Type, props);
};

Topic.textField = (_class3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(_class3, _Component2);

  function _class3() {
    babelHelpers.classCallCheck(this, _class3);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class3).apply(this, arguments));
  }

  babelHelpers.createClass(_class3, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value && this.fakeElement && this.commentField) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this5 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.props.value || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this5.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = this.fakeElement.offsetHeight;
          console.log(this.commentField.style.height = this.fakeElement.style.boxSizing == 'border-box' ? "calc(".concat(tgtH, "px + 2px)") : "calc(".concat(tgtH, "px - ").concat(cStyle.paddingTop, " - ").concat(cStyle.paddingBottom, " - ").concat(cStyle.borderTopWidth, " - ").concat(cStyle.borderBottomWidth, " + 2px)"));
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled,
          multiline = _this$props.multiline;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), !multiline && _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }), multiline && _react.default.createElement("textarea", {
        ref: this.gotCommentField,
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        rows: "3",
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }), multiline && _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.props.value ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }));
    }
  }]);
  return _class3;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setValue"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotCommentField"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotFakeElement"), _class3.prototype)), _class3);